<template>
  <div class="tags-view-container">
    <div class="tags-view-wrapper" ref="scrollWrapper">
      <div
        v-for="tag in visitedViews"
        :key="tag.path"
        class="tags-view-item"
        :class="isActive(tag) ? 'active' : ''"
        :data-path="tag.path"
        @click="clickTag(tag)"
        @contextmenu.prevent="openMenu(tag, $event)"
      >
        <span class="tag-dot" v-if="isActive(tag)"></span>
        {{ tag.title }}
        <span
          v-if="!isAffix(tag)"
          class="el-icon-close"
          @click.stop="closeTag(tag)"
        ></span>
      </div>
    </div>
    <div class="tags-view-actions">
      <el-dropdown @command="handleCommand" trigger="click">
        <span class="el-dropdown-link">
          <i class="el-icon-arrow-down"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="refresh">刷新当前</el-dropdown-item>
          <el-dropdown-item command="close">关闭当前</el-dropdown-item>
          <el-dropdown-item command="closeOthers">关闭其他</el-dropdown-item>
          <el-dropdown-item command="closeAll">关闭全部</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!-- 右键菜单 -->
    <ul
      v-show="visibleMenu"
      :style="{ left: menuLeft + 'px', top: menuTop + 'px' }"
      class="contextmenu"
    >
      <li @click="refreshSelectedTag(selectedTag)">刷新</li>
      <li v-if="!isAffix(selectedTag)" @click="closeTag(selectedTag)">关闭</li>
      <li @click="closeOthersTags">关闭其他</li>
      <li @click="closeAllTags(selectedTag)">关闭全部</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'TagsView',
  data() {
    return {
      visibleMenu: false,
      menuTop: 0,
      menuLeft: 0,
      selectedTag: {},
    }
  },
  computed: {
    visitedViews() {
      return this.$store.state.tagsView.visitedViews
    },
    routes() {
      return this.$store.state.permission.routes
    },
  },
  watch: {
    $route() {
      this.addTags()
      this.moveToCurrentTag()
    },
    visibleMenu(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    },
  },
  mounted() {
    this.initTags()
    this.addTags()
  },
  methods: {
    isActive(route) {
      return route.path === this.$route.path
    },
    isAffix(tag) {
      return tag.meta && tag.meta.affix
    },
    filterAffixTags(routes, basePath = '/') {
      let tags = []
      routes.forEach(route => {
        if (route.meta && route.meta.affix) {
          const tagPath = route.path.startsWith('/')
            ? route.path
            : basePath + '/' + route.path
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            name: route.name,
            meta: { ...route.meta },
          })
        }
        if (route.children) {
          const childTags = this.filterAffixTags(route.children, route.path)
          if (childTags.length >= 1) {
            tags = [...tags, ...childTags]
          }
        }
      })
      return tags
    },
    initTags() {
      const affixTags = this.filterAffixTags(this.routes)
      for (const tag of affixTags) {
        // 需要有 name 才能被缓存
        if (tag.name) {
          this.$store.dispatch('tagsView/addVisitedView', tag)
        }
      }
    },
    addTags() {
      const { name } = this.$route
      if (name) {
        this.$store.dispatch('tagsView/addView', this.$route)
      }
      return false
    },
    moveToCurrentTag() {
      const tags = this.$refs.scrollWrapper.querySelectorAll('.tags-view-item')
      this.$nextTick(() => {
        for (const tag of tags) {
          if (tag.dataset && tag.dataset.path === this.$route.path) {
            this.scrollToTag(tag)
          }
        }
      })
    },
    scrollToTag(tag) {
      // 简单滚动逻辑：确保当前标签可见
      const wrapper = this.$refs.scrollWrapper
      const wrapperWidth = wrapper.offsetWidth
      const tagLeft = tag.offsetLeft
      const tagWidth = tag.offsetWidth
      const scrollLeft = wrapper.scrollLeft
      if (tagLeft < scrollLeft) {
        wrapper.scrollLeft = tagLeft
      } else if (tagLeft + tagWidth > scrollLeft + wrapperWidth) {
        wrapper.scrollLeft = tagLeft + tagWidth - wrapperWidth
      }
    },
    clickTag(tag) {
      if (tag.path !== this.$route.path) {
        this.$router.push(tag.path)
      }
    },
    refreshSelectedTag(view) {
      this.$store.dispatch('tagsView/refreshView', view).then(() => {
        const { fullPath } = view
        this.$nextTick(() => {
          this.$router.replace({ path: '/redirect' + fullPath })
        })
      })
    },
    closeTag(view) {
      this.$store.dispatch('tagsView/delView', view).then(({ visitedViews }) => {
        if (this.isActive(view)) {
          this.toLastView(visitedViews, view)
        }
      })
    },
    closeOthersTags() {
      this.$router.push(this.selectedTag.path)
      this.$store.dispatch('tagsView/delOthersViews', this.selectedTag)
    },
    closeAllTags(view) {
      this.$store.dispatch('tagsView/delAllViews').then(({ visitedViews }) => {
        // 固标签不会被关闭，如果当前路由仍存在则留在当前页
        if (visitedViews.some(tag => tag.path === view.path)) {
          return
        }
        this.toLastView(visitedViews, view)
      })
    },
    toLastView(visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0]
      if (latestView) {
        this.$router.push(latestView.path)
      } else {
        this.$router.push('/')
      }
    },
    openMenu(tag, e) {
      const menuMinWidth = 105
      const offsetLeft = this.$el.getBoundingClientRect().left
      const offsetWidth = this.$el.offsetWidth
      const maxLeft = offsetWidth - menuMinWidth
      const left = e.clientX - offsetLeft + 15
      if (left > maxLeft) {
        this.menuLeft = maxLeft
      } else {
        this.menuLeft = left
      }
      this.menuTop = e.clientY - 60
      this.visibleMenu = true
      this.selectedTag = tag
    },
    closeMenu() {
      this.visibleMenu = false
    },
    handleCommand(command) {
      const view = this.visitedViews.find(v => v.path === this.$route.path)
      if (!view) return
      this.selectedTag = view
      if (command === 'refresh') {
        this.refreshSelectedTag(view)
      } else if (command === 'close') {
        if (!this.isAffix(view)) {
          this.closeTag(view)
        }
      } else if (command === 'closeOthers') {
        this.closeOthersTags()
      } else if (command === 'closeAll') {
        this.closeAllTags(view)
      }
    },
  },
}
</script>

<style scoped>
.tags-view-container {
  height: 34px;
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #d8dce5;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.04);
  display: flex;
  align-items: center;
  position: relative;
}
.tags-view-wrapper {
  flex: 1;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 8px;
}
.tags-view-wrapper::-webkit-scrollbar {
  height: 0;
}
.tags-view-item {
  display: inline-flex;
  align-items: center;
  height: 26px;
  line-height: 26px;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  color: #495060;
  background: #fff;
  padding: 0 8px;
  font-size: 12px;
  margin-left: 5px;
  cursor: pointer;
  white-space: nowrap;
  user-select: none;
  transition: all 0.2s;
}
.tags-view-item:first-of-type {
  margin-left: 0;
}
.tags-view-item:hover {
  color: #006cff;
  border-color: #006cff;
}
.tags-view-item.active {
  background-color: #006cff;
  color: #fff;
  border-color: #006cff;
}
.tags-view-item.active:hover {
  color: #fff;
}
.tag-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #fff;
  margin-right: 5px;
}
.tags-view-item .el-icon-close {
  width: 16px;
  height: 16px;
  line-height: 16px;
  text-align: center;
  border-radius: 50%;
  margin-left: 4px;
  font-size: 12px;
  transition: all 0.2s;
}
.tags-view-item .el-icon-close:hover {
  background: rgba(255, 255, 255, 0.5);
  color: #333;
}
.tags-view-actions {
  flex-shrink: 0;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 12px;
  border-left: 1px solid #e8e8e8;
  cursor: pointer;
}
.tags-view-actions .el-dropdown-link {
  cursor: pointer;
  font-size: 14px;
  color: #5a5e66;
}
.tags-view-actions .el-dropdown-link:hover {
  color: #006cff;
}
.contextmenu {
  position: fixed;
  background: #fff;
  z-index: 3000;
  list-style: none;
  padding: 5px 0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  box-shadow: 2px 2px 12px rgba(0, 0, 0, 0.12);
  margin: 0;
}
.contextmenu li {
  margin: 0;
  padding: 7px 16px;
  cursor: pointer;
}
.contextmenu li:hover {
  background: #f2f2f2;
}
</style>



// WEBPACK FOOTER //
// src/components/TagsView.vue